module.exports = __webpack_public_path__ + "media/images/user2-160x160-86b67156687e9bef504c2c361e73ef2b.jpg";